import { FOLDER_MESSAGES_NOTARY_API_VALIDATION_GROUP } from "./commonUiI18nPart1_sliceC_folderMessagesNotaryApiValidation";
import { workspaceDemonstrativeTarget, workspaceNounLower, workspaceNounTitle, workspaceOfPhrase, workspacePluralTitle, workspaceSubject } from "@Front/Utils/publicSiteBranding";
import { buildAskDocumentsWrongOfficeMessage, buildCreateFolderNoActiveOfficeErrorMessage } from "./commonUiI18nOrganizationHelpers";
import { COMMON_UI_I18N_FOLDER_STATUS_MESSAGES } from "./commonUiI18nFolderStatusMessages";

/** Slice C — member through folderMessages */
export const COMMON_UI_I18N_PART1_SLICE_C = {
	member: {
		yesRemoveCta: "Oui, retirer le membre",
		assignVoteCta: "Attribuer un vote",
		removeMyVoteCta: "Retirer mon vote",
	},
	adminTools: {
		viewDataCta: "Voir les données",
		openInMempoolCta: "Ouvrir dans le mempool",
		downloadOrOpenIpfsCta: "Télécharger / ouvrir le fichier",
		viewJobStatusDetailsCta: "Voir les détails du jobStatus",
		anchorJobStatusDetailsTitle: "Détails du jobStatus - Ancrage Bitcoin",
		idNotUserDetailsTitlePrefix: "Profil ID.NOT",
		idNotOfficeDetailsTitlePrefix: "Office ID.NOT",
	},
	role: {
		selectAllLabel: "Tout sélectionner",
	},
	folderMessages: {
		archiveModalTitle: "Voulez-vous archiver ce dossier ?",
		archiveModalBody:
			"Archiver ce dossier le déplacera dans la section des dossiers archivés. Vous pouvez ajouter une note de dossier avant d'archiver si vous le souhaitez.",
		archiveNotePlaceholder: "Écrire une note",
		deleteFolderTitle: "Supprimer le dossier",
		deleteFolderConfirmTitle: "Êtes-vous sûr de vouloir supprimer ce dossier ?",
		deleteFolderSoftDeleteWarning: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.deletion.softDeleteWarning,
		deleteFolderRetentionMessage: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.deletion.retentionMessage,
		deleteFolderIrreversibleMessage: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.deletion.irreversibleMessage,
		stakeholdersPageLoadingTitle: "Chargement de la page…",
		noteLoadingTitle: "Chargement de la note…",
		stakeholdersPageRenderIncident:
			"Un incident d'affichage est survenu. Vous pouvez réessayer ou recharger la page.",
		stakeholdersFolderLoadingTitle: "Chargement du dossier…",
		stakeholdersHeaderDescription:
			"Ajoutez les clients, acteurs tiers et confrères avant d'entrer dans le dossier.",
		stakeholdersPermissionsLoading: "Chargement de vos droits…",
		stakeholdersPermissionsDenied:
			"Vous n'avez pas les permissions nécessaires pour gérer les participants de ce dossier.",
		stakeholdersDataLoading: "Chargement des données du dossier…",
		mainContactLabel: "Personne en charge",
		thirdPartiesSectionDescription: "Ajoutez des professionnels externes qui auront un accès sécurisé à leurs documents.",
		thirdPartiesSectionPermissionDenied: "Vous n'avez pas accès à la gestion des acteurs tiers pour ce dossier.",
		confreresSectionDescription: "Invitez d'autres études notariales à consulter ce dossier.",
		confreresSectionPermissionDenied: "Vous n'avez pas les droits pour partager ce dossier avec d'autres études.",
		confrereInviteTitle: "Inviter un confrère au dossier",
		confrereSearchLabel: "Notaire (recherche annuaire)",
		confrereSearchAriaLabel: "Recherche notaire annuaire",
		confrereSearchResultsAriaLabel: "Résultats de recherche notaires",
		confrereSearchLoading: "Recherche des notaires...",
		confrereOfficeSearchLabel: `${workspaceNounTitle()} (recherche annuaire)`,
		confrereOfficeSearchAriaLabel: `Recherche ${workspaceNounLower()} annuaire`,
		confrereOfficeSearchResultsAriaLabel: `Résultats de recherche ${workspacePluralTitle().toLowerCase()}`,
		confrereOfficeSearchLoading: `Recherche des ${workspacePluralTitle().toLowerCase()}...`,
		confrereOfficeSearchLoadMore: "Voir plus de résultats",
		confrereOfficeSearchLoadMoreWithQueryPrefix: 'Voir plus de résultats avec "',
		confrereOfficeSearchLoadMoreWithQuerySuffix: '"',
		confrereCollaboratorLabel: `Collaborateur ${workspaceOfPhrase()}`,
		confrereInviteActifLabel: "actif",
		confrereInviteRoleNotSpecifiedPlaceholder: "—",
		confrereInviteIdNotRoleShort: "IdNot",
		confrereInviteLeCoffreRoleShort: "LeCoffre",
		confrereCollaboratorResultsAriaLabel: `Collaborateurs ${workspaceOfPhrase()}`,
		confrereCollaboratorsListLoading: "Chargement des membres…",
		confrereCollaboratorsListEmpty: `Aucun collaborateur rattaché à ${workspaceDemonstrativeTarget()}.`,
		confrerePreferredEmailLabel: "Email de contact et d'envoi",
		confrerePreferredEmailAriaLabel:
			"Adresse enregistrée sur le partage avec le confrère : utilisée pour les envois d'email et affichée comme coordonnée du contact. À la sélection du notaire dans l'annuaire, la valeur IdNot est proposée par défaut lorsqu'elle est disponible ; vous pouvez la modifier avant d'ajouter le confrère.",
		confrerePreferredEmailHelper:
			"Obligatoire pour valider l'invitation. Cette adresse est conservée sur le dossier : elle sert aux courriels vers le confrère et apparaît dans les contacts. IdNot ne fournit qu'une valeur initiale au moment du choix du collaborateur ; vous pouvez la corriger si besoin.",
		confrerePreferredEmailRequiredError:
			"Saisissez l'email de contact et d'envoi du confrère : il est enregistré sur le partage et permet la première connexion même si IdNot n'affiche pas d'email professionnel sur le rattachement.",
		confrerePreferredEmailFormatError: "Le format de l'email de contact n'est pas valide.",
		confrereAddButton: "Ajouter aux confrères invités",
		notaryMissingContactEmailModalTitle: "Compléter votre email de contact",
		notaryMissingContactEmailModalBody:
			"Aucune adresse email n’est enregistrée sur votre fiche notaire dans LeCoffre (par exemple après une connexion IdNot sans email professionnel sur le rattachement). Renseignez une adresse utilisée pour les échanges et l’affichage de vos coordonnées. Les notaires invités concernés voient aussi ce message.",
		notaryMissingContactEmailModalPlaceholder: "vous@etude.notaires.fr",
		notaryMissingContactEmailModalSave: "Enregistrer",
		notaryMissingContactEmailModalLater: "Plus tard",
		notaryMissingContactEmailModalSaveError: "Enregistrement impossible. Vérifiez le format de l’adresse et réessayez.",
		createNewCustomerTitle: "Créer un nouveau client",
		thirdPartyCreateTitle: "Créer un nouveau tiers",
		addThirdPartyPageTitle: "Ajouter un acteur tiers au dossier",
		addThirdPartyLoadingFolderTitle: "Chargement du dossier…",
		addThirdPartyDescription:
			"Les tiers (courtiers, agents immobiliers, etc.) recevront un code de vérification par email pour accéder à leurs documents.",
		addThirdPartyPermissionsDenied: "Vous ne disposez pas des droits nécessaires pour ajouter des tiers sur ce dossier.",
		folderNeedHelpTitle: "Besoin d'aide ?",
		folderNeedHelpDescription: "Consultez nos guides pour bien démarrer.",
		folderNeedHelpButton: "Accéder aux guides",
		folderSupportTitle: "Vous avez des questions ?",
		folderSupportDescription: "Notre équipe de support est là pour vous aider.",
		folderSupportButton: "Contactez le support",
		noFolderTitle: "Aucun dossier créé",
		noFolderDescription:
			"Vous n'avez pas encore de dossier créé. En quelques clics, commencez un nouveau dossier pour organiser et sécuriser vos documents notariés.",
		noFolderCreateCta: "Créer votre premier dossier",
		askDocumentsLoadingFolderTitle: "Chargement du dossier…",
		askDocumentsNoPermission:
			"Vous ne disposez pas des droits nécessaires pour solliciter de nouveaux documents sur ce dossier.",
		askDocumentsWrongOffice: buildAskDocumentsWrongOfficeMessage(),
		askDocumentsNoDocumentType:
			"Aucun type de document disponible. Ajoutez un document ou vérifiez la configuration du dossier.",
		askDocumentsPageTitleDefault: "Demander des documents",
		askDocumentsPageTitlePeerNotary: "Demander un document au confrère",
		askDocumentsParameterDocumentNamePlaceholder: "Nom du document à ajouter",
		askDocumentsParameterDescriptionPlaceholder: "Description visible par le client",
		askDocumentsParameterModalTitle: "Ajouter un document",
		unarchiveFolderConfirmTitle: "Désarchiver le dossier ?",
		unarchiveFolderConfirmMessage: "Êtes-vous sûr de vouloir désarchiver ce dossier ?",
		unarchiveFolderSuccessDescription: "Le dossier a été désarchivé avec succès.",
		unarchiveFolderErrorPrefix: "Erreur lors du désarchivage du dossier:",
		noClientAddClientTitle: "Ajouter des clients au dossier",
		noClientAddClientDescription:
			"Pour pouvoir faire une demande de document, vous devez d'abord ajouter un ou plusieurs clients à ce dossier. Cette étape est essentielle pour assurer le suivi et la gestion des documents.",
		noClientAddClientCta: "Ajouter un client",
		noClientAddThirdPartyTitle: "Ajouter un tiers",
		noClientAddThirdPartyDescription:
			"Ajoutez rapidement un courtier, un agent immobilier ou tout autre acteur externe pour lui demander ou partager des documents.",
		noClientAddThirdPartyCta: "Ajouter un tiers",
		noClientShareConfrereTitle: "Partager le dossier avec un confrère",
		noClientShareConfrereDescription:
			"Invitez un notaire ou un collaborateur d'une autre étude pour travailler sur ce dossier en toute sécurité.",
		noClientShareConfrereCta: "Partager avec un confrère",
		deleteCustomerFromFolderTitle: "Êtes-vous sûr de vouloir supprimer ce client du dossier ?",
		deleteCustomerFromFolderMessage:
			"Cette action retirera le client de ce dossier. Vous ne pourrez plus récupérer les informations associées à ce client dans ce dossier une fois supprimées.",
		deleteCustomerFromFolderConfirmCta: "Supprimer le client",
		deleteCustomerFromFolderError: "Impossible de supprimer le client du dossier",
		deleteAskedDocumentTitle: "Êtes-vous sûr de vouloir supprimer cette demande de document ?",
		deleteAskedDocumentMessage: "Cette action annulera la demande du document en cours.",
		deleteAskedDocumentConfirmCta: "Supprimer la demande",
		deleteAskedDocumentError: "Impossible de supprimer la demande de document",
		deleteSentDocumentTitle: "Supprimer l'envoi de document ?",
		deleteSentDocumentMessage: "Cette action annulera l'envoi du document.",
		deleteSentDocumentConfirmCta: "Oui, supprimer",
		deleteSentDocumentError: "Impossible de supprimer l'envoi de document",
		deleteFolderError: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.deletion.errorMessage,
		createFolderUnexpectedError: "Une erreur inattendue s'est produite pendant la création du dossier.",
		createFolderDuplicateNumberError: "Numéro de dossier déjà existant",
		createFolderMissingUidError: "Une erreur s'est produite lors de la création du dossier. Veuillez réessayer.",
		createFolderNoActiveOfficeError: buildCreateFolderNoActiveOfficeErrorMessage(),
		deleteFolderConfirmationInputLabel: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.deletion.confirmationInputLabel,
		deleteFolderConfirmationErrorPrefix: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.deletion.confirmationErrorPrefix,
		deleteFolderConfirmationErrorSuffix: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.deletion.confirmationErrorSuffix,
		deleteThirdPartyFromFolderTitle: "Supprimer le tiers du dossier ?",
		deleteThirdPartyFromFolderMessagePrefix: "Voulez-vous vraiment supprimer le tiers",
		deleteThirdPartyFromFolderMessageSuffix: "de ce dossier ?",
		deleteThirdPartyFromFolderFallbackName: "ce tiers",
		deleteThirdPartyFromFolderConfirmCta: "Supprimer le tiers",
		deleteThirdPartyFromFolderErrorTitle: "Erreur",
		deleteThirdPartyFromFolderSuccessTitle: "Succès !",
		deleteThirdPartyFromFolderSuccessDescription: "Le tiers a été supprimé avec succès.",
		deleteThirdPartyFromFolderAlreadyDeletedDescription: "Ce tiers était déjà supprimé. La liste a été actualisée.",
		deleteThirdPartyFromFolderError: "Impossible de supprimer le tiers",
		revokeSharedNotaryError: "Impossible de révoquer le partage",
		deleteDocumentSuccessTitle: "Succès !",
		deleteDocumentSuccessDescription: "Le document a été supprimé avec succès.",
		parameterDocumentsNoDeedError: "Ce dossier ne permet pas d'ajouter des documents.",
		parameterDocumentsNameRequiredWarning: "Le nom du document est requis.",
		parameterDocumentsNoOfficeError: `Impossible de déterminer ${workspaceSubject()} associé.`,
		parameterDocumentsCreateError: "Impossible de créer ce document.",
		parameterDocumentsAttachError: "Impossible d'ajouter ces documents.",
		createFolderGuestWarning: `Vous ne pouvez pas créer de dossier dans un ${workspaceNounLower()} où vous êtes invité`,
		askDocumentsRateLimitError: "Vous avez effectué trop de requêtes. Veuillez patienter quelques instants.",
		askDocumentsLoadFolderInfoError: "Impossible de charger les informations du dossier.",
		askDocumentsLoadAvailableDocumentsError: "Impossible de charger la liste des documents disponibles.",
		askDocumentsNoValidDocumentsWarning:
			"Aucun document valide à demander. Certains documents sont déjà demandés ou validés.",
		askDocumentsSubmitError: "Impossible d'envoyer la demande de documents.",
		askDocumentsBatchPartialTitle: "Demande partielle",
		askDocumentsFolderNotFoundError: "Dossier introuvable.",
		askDocumentsSelectAtLeastOneWarning: "Veuillez sélectionner au moins un document à demander.",
		sendDocumentsNoFilesWarning: "Veuillez ajouter au moins un fichier à envoyer.",
		sendDocumentsSelectRecipientsWarning: "Veuillez sélectionner au moins un destinataire avant d'envoyer.",
		sendDocumentsMissingFolderError: "Impossible de déterminer le dossier. Veuillez réessayer.",
		sendDocumentsSubmissionError: "Erreur lors de l'envoi des documents",
		sendDocumentsLoadFolderInfoError: "Impossible de charger les informations du dossier.",
		addClientLoadCustomersWarning: "Le chargement des clients a échoué. Vous pourrez réessayer plus tard.",
		addClientLoadThirdPartiesWarning: "Le chargement des acteurs tiers a échoué. Vous pourrez réessayer plus tard.",
		addClientLoadSharesWarning: "Le chargement des partages a échoué. Vous pourrez réessayer plus tard.",
		addClientAccessDeniedError: "Vous n'avez pas les permissions nécessaires pour accéder à ce dossier.",
		addClientFolderNotFoundError: "Le dossier demandé n'existe pas ou a été supprimé.",
		addClientFolderLoadError: "Nous n'avons pas pu charger les informations du dossier. Veuillez réessayer.",
		addClientInvalidFolderError: "Les données du dossier sont invalides. Veuillez réessayer.",
		addClientMismatchedFolderError: "Le dossier chargé ne correspond pas à celui demandé. Veuillez réessayer.",
		addClientFolderTimeoutError:
			"Le chargement a pris trop de temps. Veuillez réessayer ou retourner à la liste des dossiers.",
		addClientFinalizationTimeoutError:
			"La requête a pris trop de temps. Les modifications peuvent avoir été appliquées. Vérifiez l'état du dossier.",
		addClientFinalizationPartialError:
			"Certaines actions n'ont pas pu être effectuées. Les autres modifications ont été traitées.",
		addClientFinalizationPartialWarning: "Certaines opérations ont échoué. Veuillez vérifier les erreurs ci-dessus.",
		addClientDraftError: "Impossible d'ajouter ce client à la liste.",
		addClientCustomerEmailDuplicateWarning:
			"Cette adresse email est déjà utilisée par un client de l'étude. Utilisez la liste « Clients existants » ou modifiez l'email.",
		addClientCustomerEmailDuplicateLinkedWarning: "Ce client est déjà associé à ce dossier.",
		addClientCustomerEmailDuplicatePendingWarning: "Ce client est déjà dans la liste d'ajout.",
		addClientCustomerEmailDuplicateLoadedSuccessTitle: "Client existant ajouté",
		addClientCustomerEmailDuplicateLoadedSuccessDescriptionPrefix: "Le client",
		addClientCustomerEmailDuplicateLoadedSuccessDescriptionSuffix: "a été ajouté à la liste pour ce dossier.",
		addClientThirdPartyRequiredFieldsError: "Prénom, nom et email sont obligatoires pour ajouter un tiers.",
		addClientThirdPartyPendingWarning: "Ce tiers est déjà présent dans la liste.",
		addClientThirdPartyExistingWarning: "Ce tiers est déjà associé à ce dossier.",
		...FOLDER_MESSAGES_NOTARY_API_VALIDATION_GROUP,
		addClientThirdPartyCreateErrorPrefix: "Impossible d'ajouter",
		addClientThirdPartyCreateErrorSuffix: ". Les autres modifications continuent.",
		addClientThirdPartyAlreadyLinkedSuffix: "est déjà rattaché au dossier.",
		addClientThirdPartyDeleteErrorPrefix: "Impossible de supprimer",
		addClientShareRevokeErrorPrefix: "Impossible de révoquer le partage avec",
		addClientContinuationSuffix: ". Les autres modifications continuent.",
		addClientCustomerCreateErrorPrefix: "Impossible de créer le client",
		addClientCustomerAlreadyExistsPrefix: "Un client avec l'email",
		addClientCustomerAlreadyExistsSuffix: "existe déjà. Les autres modifications continuent.",
		addClientCustomerPhoneRequiredPrefix: "Le numéro de téléphone est requis pour",
		viewDocumentPermissionDeniedError: "Vous n'avez pas les droits pour valider ce document.",
		viewDocumentValidationError: "Impossible de valider le document.",
	},
} as const;
